import { questionGoToRuleDefinition, questionGoToRules } from '../../poll/questions/questionSchemaFields';
import { logicContainerDefinition, logicRuleDefinition, topLevelLogicRules } from '../../poll/questions/schemaFields';

export {
  answerAwardAmount,
  answerImage,
  answerImageBackground,
  createBasicAnswerSchema,
  questionAutoCommit,
  questionAutoNext,
  questionAwardAmount,
  questionFixedRandomizeAnswers,
  questionHasAward,
  questionHasCorrectAnswer,
  questionHasNotApplicable,
  questionHasOthers,
  questionRandomizeAnswers,
  questionRequiresAnswer,
  questionText,
} from '../../poll/questions/schemaFields';

export function createBaseQuestionSchema(properties = {}, required: string[] = []) {
  return {
    type: 'object',
    properties: {
      id: { type: 'string' },
      data: {
        type: 'object',
        properties: {
          text: { type: 'string' },
          ...questionGoToRules,
          ...topLevelLogicRules,
          ...properties,
        },
        additionalProperties: false,
        required: ['text', 'type', 'logicRules', ...required],
      },
    },
    additionalProperties: false,
    required: ['id', 'data'],
    definitions: {
      ...logicRuleDefinition,
      ...questionGoToRuleDefinition,
      ...logicContainerDefinition,
    },
  };
}
